module.exports = __webpack_public_path__ + "static/media/variant.9c5193ec.png";